import { AuxiliumComponent } from "../auxilium-component";

export class Icon extends AuxiliumComponent {
	static observedAttributes = ["icon", "colour"];

	constructor() {
		super();

		this.icon = this.getAttribute("icon") ?? "fas fa-icons";
		this.colour = this.getAttribute("colour");
	}

	parsedCallback() {
		if (this.colour) { this.dataset.colour = this.colour; }
		this.classList.add(...this.icon.split(" "));
	}

	attributeChanged(name, oldValue, newValue) {
		switch (name) {
			case "icon":
				if (oldValue) { this.classList.remove(...oldValue.split(" ")); }
				if (newValue) { this.classList.add(...newValue.split(" ")); }
				break;
			case "colour":
				if (newValue) { this.dataset.colour = this.colour; }
				else { this.removeAttribute("data-colour"); }
				break;
		}
	}
}